const EnvVars = {
  ENVOY_API_URL: 'ENVOY_API_URL',
  CLIENT_URL: 'CLIENT_URL',
  CLIENT_API_BASE: 'CLIENT_API_BASE',
  PORTAL_URL: 'PORTAL_URL',
  LD_CLIENT_ID: 'LD_CLIENT_ID',
  LD_FAKE_USER_ID: 'LD_FAKE_USER_ID',
  COOKIE_DOMAIN: 'COOKIE_DOMAIN',
  JWT_COOKIE_KEY: 'JWT_COOKIE_KEY',
  LOGIN_URL: 'LOGIN_URL',
  SFDC_BASE_URL: 'SFDC_BASE_URL',
  SFDC_APEX_URL: 'SFDC_APEX_URL',
  SFDC_CONTACT_URL: 'SFDC_CONTACT_URL',
  SFDC_OPP_URL: 'SFDC_OPP_URL',
  PENDO_APP_ID: 'PENDO_APP_ID',
  GITLAB_MERGE_ID: 'GITLAB_MERGE_ID',
  GITLAB_PROJECT_ID: 'GITLAB_PROJECT_ID',
  CLIENT_BENCH_URL: 'CLIENT_BENCH_URL',
  TABLEAU_URL_COMPANY: 'TABLEAU_URL_COMPANY',
  TABLEAU_URL_LOCATION: 'TABLEAU_URL_LOCATION',
  TABLEAU_URL_LANGUAGE: 'TABLEAU_URL_LANGUAGE',
  TABLEAU_URL_SIMILAR_TALENT: 'TABLEAU_URL_SIMILAR_TALENT',
  LOGGLY_CLIENT_ID: 'LOGGLY_CLIENT_ID',
  ENVIRONMENT_NAME: 'ENVIRONMENT_NAME',
  ENABLE_LOGGING: 'ENABLE_LOGGING',
  S3_PUBLIC_FILE_BUCKET: 'S3_PUBLIC_FILE_BUCKET',
  S3_PUBLIC_BASE_URL: 'S3_PUBLIC_BASE_URL',
  GOOGLE_MAPS_API_URL: 'GOOGLE_MAPS_API_URL',
  HUBSPOT_TALENT_FINDER: 'HUBSPOT_TALENT_FINDER',
  LOGO_DEV_BASE_URL: 'LOGO_DEV_BASE_URL',
  LOGO_DEV_PUBLISHABLE_KEY: 'LOGO_DEV_PUBLISHABLE_KEY',
  MY_APPS_URL: 'MY_APPS_URL',
  PROPOSED_BURDENED_HELP_LINK: 'PROPOSED_BURDENED_HELP_LINK',
  ENABLE_SUGGESTIONS: 'ENABLE_SUGGESTIONS',
  ENABLE_CHAXIOM_HEADER_LINK: 'ENABLE_CHAXIOM_HEADER_LINK',
  ENABLE_CUSTOM_WARMING: 'ENABLE_CUSTOM_WARMING',
  ENABLE_CALENDAR_EVENTS_TODAY: 'ENABLE_CALENDAR_EVENTS_TODAY',
  ONBOARDING_TIME_ENTRY_URL: 'ONBOARDING_TIME_ENTRY_URL',
  ONBOARDING_LINKEDIN_GUIDE_URL: 'ONBOARDING_LINKEDIN_GUIDE_URL',
  ONBOARDING_AODA_INSTRUCTIONS_URL: 'ONBOARDING_AODA_INSTRUCTIONS_URL',
  ONBOARDING_LSO_LAWPRO_URL: 'ONBOARDING_LSO_LAWPRO_URL',
  ONBOARDING_LAW_SOCIETY_GUIDE_URL: 'ONBOARDING_LAW_SOCIETY_GUIDE_URL',
  ONBOARDING_ENGAGEMENT_SUCCESS_URL: 'ONBOARDING_ENGAGEMENT_SUCCESS_URL',
  ONBOARDING_ENCRYPTED_EMAIL_URL: 'ONBOARDING_ENCRYPTED_EMAIL_URL',
  WORKDAY_HELPCENTER_URL: 'WORKDAY_HELPCENTER_URL',
  AXIOM_SEISMIC_SCREEN_RESOLUTION_INFO_URL:
    'AXIOM_SEISMIC_SCREEN_RESOLUTION_INFO_URL',
  CONTACT_SERVICEDESK_URL: 'CONTACT_SERVICEDESK_URL',
  REPORT_AN_ISSUE_URL: 'REPORT_AN_ISSUE_URL',
};

let envs = {};

const EnvUtil = {
  initialize(env) {
    envs = this.pluckAllowedFrom(env);
  },

  getAllowedFrontendProcessVars() {
    return Object.values(EnvVars);
  },

  pluckAllowedFrom(obj) {
    const allowedProps = {};
    this.getAllowedFrontendProcessVars().forEach(propName => {
      allowedProps[propName] = obj[propName] || null;
    });

    return allowedProps;
  },

  get loginUrl() {
    return envs[EnvVars.LOGIN_URL];
  },

  get clientUrl() {
    return envs[EnvVars.CLIENT_URL];
  },

  get portalUrl() {
    return envs[EnvVars.PORTAL_URL];
  },

  get apiEnvoyUrl() {
    return envs[EnvVars.ENVOY_API_URL];
  },

  get cookieDomain() {
    return envs[EnvVars.COOKIE_DOMAIN];
  },

  get userCookieName() {
    return envs[EnvVars.JWT_COOKIE_KEY];
  },

  get sfdcBaseUrl() {
    return envs[EnvVars.SFDC_BASE_URL];
  },

  get sfdcContactUrl() {
    return envs[EnvVars.SFDC_CONTACT_URL];
  },

  get sfdcOppUrl() {
    return envs[EnvVars.SFDC_OPP_URL];
  },

  get pendoAppId() {
    return envs[EnvVars.PENDO_APP_ID];
  },

  get gitLabMergeId() {
    return envs[EnvVars.GITLAB_MERGE_ID];
  },

  get gitLabProjectId() {
    return envs[EnvVars.GITLAB_PROJECT_ID];
  },

  get clientApiBase() {
    return envs[EnvVars.CLIENT_API_BASE] || '/api';
  },

  get clientBenchUrl() {
    return envs[EnvVars.CLIENT_BENCH_URL];
  },

  get tableauCompanyUrl() {
    return envs[EnvVars.TABLEAU_URL_COMPANY];
  },

  get tableauLocationUrl() {
    return envs[EnvVars.TABLEAU_URL_LOCATION];
  },

  get tableauLanguageUrl() {
    return envs[EnvVars.TABLEAU_URL_LANGUAGE];
  },

  get tableauSimilarTalentUrl() {
    return envs[EnvVars.TABLEAU_URL_SIMILAR_TALENT];
  },

  get logglyClientId() {
    return envs[EnvVars.LOGGLY_CLIENT_ID];
  },

  get environmentName() {
    return envs[EnvVars.ENVIRONMENT_NAME];
  },

  get enableLogging() {
    return (
      envs[EnvVars.ENABLE_LOGGING] === true ||
      envs[EnvVars.ENABLE_LOGGING] === 'true'
    );
  },

  get publicS3Bucket() {
    return envs[EnvVars.S3_PUBLIC_FILE_BUCKET];
  },

  get publicBaseUrlS3() {
    return envs[EnvVars.S3_PUBLIC_BASE_URL];
  },

  get axiomSeismicScreenResolutionInfoUrl() {
    return envs[EnvVars.AXIOM_SEISMIC_SCREEN_RESOLUTION_INFO_URL];
  },

  get contactServicesdeskUrl() {
    return envs[EnvVars.CONTACT_SERVICEDESK_URL];
  },

  get reportAnIssueUrl() {
    return envs[EnvVars.REPORT_AN_ISSUE_URL];
  },

  get googleMapsApiUrl() {
    // something (yaml parser?) encodes these characters
    return (envs[EnvVars.GOOGLE_MAPS_API_URL] ?? '')
      .replaceAll('&#x3D;', '=')
      .replaceAll('&amp;', '&');
  },

  get hubspotTalentFinder() {
    return envs[EnvVars.HUBSPOT_TALENT_FINDER];
  },

  get logoDevBaseUrl() {
    return envs[EnvVars.LOGO_DEV_BASE_URL];
  },

  get logoDevPublishableKey() {
    return envs[EnvVars.LOGO_DEV_PUBLISHABLE_KEY];
  },

  get myAppsUrl() {
    return envs[EnvVars.MY_APPS_URL];
  },

  get proposedBurdenedHelpLink() {
    return envs[EnvVars.PROPOSED_BURDENED_HELP_LINK];
  },

  get enableSuggestions() {
    return (
      envs[EnvVars.ENABLE_SUGGESTIONS] === true ||
      envs[EnvVars.ENABLE_SUGGESTIONS] === 'true'
    );
  },

  get enableCalendarEventsToday() {
    return (
      envs[EnvVars.ENABLE_CALENDAR_EVENTS_TODAY] === true ||
      envs[EnvVars.ENABLE_CALENDAR_EVENTS_TODAY] === 'true'
    ).toString();
  },

  get onboardingTimeEntryUrl() {
    return envs[EnvVars.ONBOARDING_TIME_ENTRY_URL];
  },

  get onboardingLinkedinGuideUrl() {
    return envs[EnvVars.ONBOARDING_LINKEDIN_GUIDE_URL];
  },

  get onboardingAodaInstructionsUrl() {
    return envs[EnvVars.ONBOARDING_AODA_INSTRUCTIONS_URL];
  },

  get onboardingLsoLawproUrl() {
    return envs[EnvVars.ONBOARDING_LSO_LAWPRO_URL];
  },

  get onboardingLawSocietyGuideUrl() {
    return envs[EnvVars.ONBOARDING_LAW_SOCIETY_GUIDE_URL];
  },

  get onboardingEngagementSuccessUrl() {
    return envs[EnvVars.ONBOARDING_ENGAGEMENT_SUCCESS_URL];
  },

  get onboardingEncryptedEmailUrl() {
    return envs[EnvVars.ONBOARDING_ENCRYPTED_EMAIL_URL];
  },

  get workdayHelpcenterUrl() {
    return envs[EnvVars.WORKDAY_HELPCENTER_URL];
  },

  get enableChaxiomHeaderLink() {
    return (
      envs[EnvVars.ENABLE_CHAXIOM_HEADER_LINK] === true ||
      envs[EnvVars.ENABLE_CHAXIOM_HEADER_LINK] === 'true'
    );
  },

  get enableCustomWarming() {
    return (
      envs[EnvVars.ENABLE_CUSTOM_WARMING] === true ||
      envs[EnvVars.ENABLE_CUSTOM_WARMING] === 'true'
    );
  },
};

try {
  EnvUtil.initialize(window?.ENV || {});
  // eslint-disable-next-line no-empty
} catch {}

// eslint-disable-next-line unicorn/prefer-module
module.exports = { EnvUtil };
